import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '@delroydsouza/orders';
import { MessageService } from 'primeng/api';
import { OrdersService } from '../../services/orders.service';

@Component({
  selector: 'orders-thank-you',
  templateUrl: './thank-you.component.html',
  styles: [],
})
export class ThankYouComponent implements OnInit {
  constructor(
    private orderService: OrdersService,
    private messageService: MessageService,
    private router: Router,
    private cartService: CartService
  ) {}

  ngOnInit(): void {
    const orderData = this.orderService.getCacheOrderData();

    this.orderService.createOrder(orderData).subscribe(
      () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Order Placed Successfully',
        });
        // this.router.navigate(['/success']);
        this.cartService.emptyCart();
        this.orderService.removeCacheOrderData();
      },
      () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Order not placed',
        });
      }
    );
  }
}
